import axios from '@/axiosInterceptor';
import { jsonToFormData } from '@/common/json';
// import placeholderFormData from "@/common/placeholderFormData";

const state = () => ({
  showCarrier: null,
  showCarrierInsights: [],
  showCarrierHistoricalTouches: [],
  searchResults: [],
  myCarrierResults: [],
  filters: {
    onlyMyCarrier: true,
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  },
  carrierVerification: {},
  contracts: {},
  carrierData: {},
  carrierDetails: {},
  maskedContacts: [],
  isEmailRequiredForLogin: false,
  rulesSyntax: [],
  availableCarrierElectedClassificationsHaveLoaded: false,
  hasCompletedCarrierElectedClassificationsStage: false,
  availableCarrierElectedClassifications: [],
  carrierElectedClassifications: [],
  connectionClassifications: [],
  failedRulesAssessmentData: null,
  showCarrierInspections: null,
  showCarrierSafety: null,
  loadAnalysis: {
    rule: {
      triumph_pay_load_indicator_passing: 2,
    },
    tpay_loads_rolling_averages: [
      {
        date_start: '2023-12-26',
        date_end: '2024-01-09',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 445,
        miles: 316082.19539685384,
        average_haul: 710.2970683075367,
        overage_ratio: 0.07756618291947334,
      },
      {
        date_start: '2023-12-25',
        date_end: '2024-01-08',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 463,
        miles: 329833.38087156805,
        average_haul: 712.3831120336243,
        overage_ratio: 0.080940706962348,
      },
      {
        date_start: '2023-12-24',
        date_end: '2024-01-07',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 457,
        miles: 324839.90434057894,
        average_haul: 710.8094186883566,
        overage_ratio: 0.07971531394860833,
      },
      {
        date_start: '2023-12-23',
        date_end: '2024-01-06',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 464,
        miles: 331450.3579413399,
        average_haul: 714.3326679770256,
        overage_ratio: 0.08133751115124906,
      },
      {
        date_start: '2023-12-22',
        date_end: '2024-01-05',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 479,
        miles: 344838.1093830934,
        average_haul: 719.9125456849549,
        overage_ratio: 0.08462284892836648,
      },
      {
        date_start: '2023-12-21',
        date_end: '2024-01-04',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 523,
        miles: 377912.72079777974,
        average_haul: 722.5864642404966,
        overage_ratio: 0.09273931798718521,
      },
      {
        date_start: '2023-12-20',
        date_end: '2024-01-03',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 528,
        miles: 385243.1712230573,
        average_haul: 729.6272182254874,
        overage_ratio: 0.09453820152713063,
      },
      {
        date_start: '2023-12-19',
        date_end: '2024-01-02',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 568,
        miles: 414691.03167034115,
        average_haul: 730.0898444900372,
        overage_ratio: 0.10176467034854998,
      },
      {
        date_start: '2023-12-18',
        date_end: '2024-01-01',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 586,
        miles: 427074.43741985154,
        average_haul: 728.795968293262,
        overage_ratio: 0.10480354292511694,
      },
      {
        date_start: '2023-12-17',
        date_end: '2023-12-31',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 593,
        miles: 429029.32072316896,
        average_haul: 723.489579634349,
        overage_ratio: 0.10528326888912122,
      },
      {
        date_start: '2023-12-16',
        date_end: '2023-12-30',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 602,
        miles: 438761.8370605141,
        average_haul: 728.8402608978639,
        overage_ratio: 0.10767161645656788,
      },
      {
        date_start: '2023-12-15',
        date_end: '2023-12-29',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 624,
        miles: 451477.96382074815,
        average_haul: 723.5223779178656,
        overage_ratio: 0.11079213836091979,
      },
      {
        date_start: '2023-12-14',
        date_end: '2023-12-28',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 614,
        miles: 444418.90859651536,
        average_haul: 723.8092973884615,
        overage_ratio: 0.10905985487031052,
      },
      {
        date_start: '2023-12-13',
        date_end: '2023-12-27',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 627,
        miles: 444957.9165120111,
        average_haul: 709.6617488229842,
        overage_ratio: 0.10919212675141377,
      },
      {
        date_start: '2023-12-12',
        date_end: '2023-12-26',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 633,
        miles: 452389.93741289433,
        average_haul: 714.6760464658678,
        overage_ratio: 0.11101593556144645,
      },
      {
        date_start: '2023-12-11',
        date_end: '2023-12-25',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 644,
        miles: 457228.7658924284,
        average_haul: 709.9825557335845,
        overage_ratio: 0.11220337813311126,
      },
      {
        date_start: '2023-12-10',
        date_end: '2023-12-24',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 652,
        miles: 461794.78420226113,
        average_haul: 708.2742088991735,
        overage_ratio: 0.11332387342386777,
      },
      {
        date_start: '2023-12-09',
        date_end: '2023-12-23',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 660,
        miles: 467077.4764193457,
        average_haul: 707.6931460899177,
        overage_ratio: 0.11462023961210938,
      },
      {
        date_start: '2023-12-08',
        date_end: '2023-12-22',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 661,
        miles: 464198.4357679504,
        average_haul: 702.266922493117,
        overage_ratio: 0.11391372656882218,
      },
      {
        date_start: '2023-12-07',
        date_end: '2023-12-21',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 647,
        miles: 451223.78479372,
        average_haul: 697.4092500675735,
        overage_ratio: 0.11072976313956319,
      },
      {
        date_start: '2023-12-06',
        date_end: '2023-12-20',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 602,
        miles: 421137.7558041684,
        average_haul: 699.5643784122399,
        overage_ratio: 0.10334668854090022,
      },
      {
        date_start: '2023-12-05',
        date_end: '2023-12-19',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 583,
        miles: 407400.6926776652,
        average_haul: 698.8005020200089,
        overage_ratio: 0.09997563010494852,
      },
      {
        date_start: '2023-12-04',
        date_end: '2023-12-18',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 549,
        miles: 384735.689597233,
        average_haul: 700.7936058237395,
        overage_ratio: 0.09441366615883019,
      },
      {
        date_start: '2023-12-03',
        date_end: '2023-12-17',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 547,
        miles: 385871.98675558576,
        average_haul: 705.433248182058,
        overage_ratio: 0.09469251208726032,
      },
      {
        date_start: '2023-12-02',
        date_end: '2023-12-16',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 558,
        miles: 392923.2979818419,
        average_haul: 704.1636164549138,
        overage_ratio: 0.09642289521026795,
      },
      {
        date_start: '2023-12-01',
        date_end: '2023-12-15',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 580,
        miles: 402485.7458097563,
        average_haul: 693.940941051304,
        overage_ratio: 0.09876950817417332,
      },
      {
        date_start: '2023-11-30',
        date_end: '2023-12-14',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 579,
        miles: 401673.639163331,
        average_haul: 693.7368552043713,
        overage_ratio: 0.09857021819959043,
      },
      {
        date_start: '2023-11-29',
        date_end: '2023-12-13',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 582,
        miles: 399802.5567572935,
        average_haul: 686.9459738097827,
        overage_ratio: 0.09811105687295546,
      },
      {
        date_start: '2023-11-28',
        date_end: '2023-12-12',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 592,
        miles: 407199.3975377355,
        average_haul: 687.8368201650937,
        overage_ratio: 0.09992623252459767,
      },
      {
        date_start: '2023-11-27',
        date_end: '2023-12-11',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 583,
        miles: 409677.99576642213,
        average_haul: 702.7066822751666,
        overage_ratio: 0.10053447748869254,
      },
      {
        date_start: '2023-11-26',
        date_end: '2023-12-10',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 576,
        miles: 407965.74767465715,
        average_haul: 708.2738674907242,
        overage_ratio: 0.10011429390789132,
      },
      {
        date_start: '2023-11-25',
        date_end: '2023-12-09',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 569,
        miles: 405848.9131977999,
        average_haul: 713.2669827729347,
        overage_ratio: 0.09959482532461347,
      },
      {
        date_start: '2023-11-24',
        date_end: '2023-12-08',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 586,
        miles: 416135.11501287995,
        average_haul: 710.1281826158361,
        overage_ratio: 0.1021190466289276,
      },
      {
        date_start: '2023-11-23',
        date_end: '2023-12-07',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 581,
        miles: 416255.74392050545,
        average_haul: 716.447063546481,
        overage_ratio: 0.10214864881484796,
      },
      {
        date_start: '2023-11-22',
        date_end: '2023-12-06',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 613,
        miles: 439879.2966079336,
        average_haul: 717.5844969134316,
        overage_ratio: 0.10794583965838861,
      },
      {
        date_start: '2023-11-21',
        date_end: '2023-12-05',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 630,
        miles: 452683.2416117649,
        average_haul: 718.5448279551823,
        overage_ratio: 0.11108791205196684,
      },
      {
        date_start: '2023-11-20',
        date_end: '2023-12-04',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 658,
        miles: 476064.01425353606,
        average_haul: 723.5015414187478,
        overage_ratio: 0.1168255249701929,
      },
      {
        date_start: '2023-11-19',
        date_end: '2023-12-03',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 662,
        miles: 483574.8181712369,
        average_haul: 730.4755561499047,
        overage_ratio: 0.11866866703588635,
      },
      {
        date_start: '2023-11-18',
        date_end: '2023-12-02',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 661,
        miles: 478608.66018291813,
        average_haul: 724.0675645732498,
        overage_ratio: 0.11744997795899831,
      },
      {
        date_start: '2023-11-17',
        date_end: '2023-12-01',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 681,
        miles: 497821.4806400428,
        average_haul: 731.0153900734842,
        overage_ratio: 0.12216478052516389,
      },
      {
        date_start: '2023-11-16',
        date_end: '2023-11-30',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 690,
        miles: 508342.3178844923,
        average_haul: 736.7279969340468,
        overage_ratio: 0.12474658107594902,
      },
      {
        date_start: '2023-11-15',
        date_end: '2023-11-29',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 695,
        miles: 509099.56390712754,
        average_haul: 732.5173581397519,
        overage_ratio: 0.12493240832076749,
      },
      {
        date_start: '2023-11-14',
        date_end: '2023-11-28',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 692,
        miles: 510327.28305200004,
        average_haul: 737.4671720404625,
        overage_ratio: 0.12523368909251534,
      },
      {
        date_start: '2023-11-13',
        date_end: '2023-11-27',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 699,
        miles: 518494.1072780879,
        average_haul: 741.765532586678,
        overage_ratio: 0.12723781773695408,
      },
      {
        date_start: '2023-11-12',
        date_end: '2023-11-26',
        carrier_id: 188137,
        total_observed_power_units: 815,
        total_possible_miles: 4075000,
        loads: 695,
        miles: 508791.81246484275,
        average_haul: 732.0745503091263,
        overage_ratio: 0.12485688649443993,
      },
    ],
  },
});

// getters
const getters = {
  latestTaxIdentifier: (state) => {
    const taxIdetifiersSize =
      state.carrierData?.identity?.tax_identifiers?.length;
    if (taxIdetifiersSize) {
      return state.carrierData.identity.tax_identifiers[taxIdetifiersSize - 1];
    }
    return null;
  },
};

// actions
const actions = {
  // unable to get this request to work -- using "by_identifier" instead
  async getCarriersDetail({ commit }, params) {
    const { id } = params;
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/carriers/${id}/detail`
      );
      commit('setCarrierDetails', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarrierById(_, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/carriers/' + id
      );
      // commit('setShowCarrier', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarriersDetails({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/carriers/' +
          id +
          '/detail_for_highway_broker'
      );
      commit('setShowCarrier', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarriersInsights({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/carriers/' + id + '/insights'
      );
      commit('setShowCarrierInsights', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarriersHistoricaltouches({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/carriers/' +
          id +
          '/historical_touches_by_five_zip_areas'
      );
      commit('setShowCarrierHistoricalTouches', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarrierEmailsAndPhones(_, carrierId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/carriers/${carrierId}/phone_and_email_addresses_for_carrier_identity_verification`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async searchCarrier(_, { searchText, carrierType }) {
    const params = {};
    if (parseInt(searchText)) {
      params['value'] = parseInt(searchText);
    } else {
      params['value'] = searchText;
    }
    params['is_type'] = carrierType.toUpperCase();
    try {
      const res = await axios.get(
        process.env.API_MONITOR + `/api/v1/carriers/by_identifier`,
        {
          params: params,
        }
      );

      // commit('setCarrierSearchResults', res.data);
      // commit('setPagination', res.headers);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async searchCarriers(_, { searchText, page, itemsPerPage }) {
    var params = {
      page: page,
      per_page: itemsPerPage,
      // Only carrier records where legal_name is present to skip
      // over new carrier records coming in from the L&I feed
      'q[legal_name_not_null]': 1,
      // If they are searching with a number, use against identifiers
      // only show active carriers on global search
      'q[latest_census_id_not_null]': 1,
    };
    if (parseInt(searchText)) {
      params['q[identifiers_value_non_padded_start]'] = parseInt(searchText);
      params['q[s]'] = 'identifiers_value_non_padded asc';
    } else {
      params['q[legal_name_or_dba_name_cont]'] = searchText;
      params['q[s]'] = 'legal_name asc';
    }
    try {
      const res = await axios.get(
        process.env.API_MONITOR + `/api/v1/carriers`,
        {
          params: params,
        }
      );

      // commit('setCarrierSearchResults', res.data);
      // commit('setPagination', res.headers);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getCarriersByIdentifier({ commit }, body) {
    const params = {
      is_type: body.is_type,
      value: body.value,
    };
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/carriers/by_identifier',
        {
          params: params,
        }
      );
      commit('setCarrierDetails', res.data);
      if (res.data?.is_email_required_for_login) {
        commit(
          'setEmailRequiredForLogin',
          res.data.is_email_required_for_login
        );
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarriersByCompanyId(
    { commit },
    { companyId, page, itemsPerPage, searchText }
  ) {
    const params = {
      page,
      'q[s]': 'legal_name asc',
      per_page: itemsPerPage,
      'q[subscriptions_company_id_eq]': companyId,
    };

    if (parseInt(searchText)) {
      params['q[identifiers_value_non_padded_start]'] = parseInt(searchText);
      params['q[s]'] = 'identifiers_value_non_padded asc';
    } else {
      params['q[legal_name_or_dba_name_cont]'] = searchText;
    }
    try {
      const res = await axios.get(
        process.env.API_MONITOR + `/api/v1/carriers`,
        {
          params,
        }
      );

      commit('setMycarrierResults', res.data);
      commit('setPagination', res.headers);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createSubscription({ state, commit }, carrierId) {
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/subscriptions/create_by_carrier',
        { carrier_id: carrierId }
      );
      if (state.showCarrier?.id == carrierId) {
        commit('updateShowCarrierSubscription', res.data);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async deleteSubscription({ state, commit }, carrierId) {
    try {
      let res = await axios.delete(
        process.env.API_MONITOR +
          '/api/v1/subscriptions/destroy_by_carrier?carrier_id=' +
          carrierId
      );
      if (state.showCarrier?.id == carrierId) {
        commit('updateShowCarrierSubscription', {});
      }
      commit(
        'setMycarrierResults',
        state.myCarrierResults.filter((carrier) => carrier.id !== carrierId)
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async carrierVerification({ commit }, body) {
    let formData = new FormData();
    formData.append('verification[endpoint_id]', body.endpoint_id);
    formData.append('verification[channel]', body.channel);
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/sign_up/carrier_verification',
        formData
      );
      commit('setCarrierVerification', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async carrierVerificationCode(_, body) {
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/sign_up/carrier_verification/code',
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422, 429].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async setContractInformation({ commit }, id) {
    try {
      const res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/onboarding_packets/' +
          id +
          '/contracts'
      );
      if ([200, 201].includes(res.status)) {
        commit('setCurrentContracts', res.data);
      }
      return res.data;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRulesSyntax({ commit }) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR + '/api/v1/rules/is_types'
      );
      if ([200, 201].includes(res.status)) {
        commit('setRulesSyntax', res.data);
      }
      return res.data;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRulesSyntaxByClassificationId(_, classification_id) {
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/rules/is_types?classification_id=' +
          classification_id
      );
      // if ([200, 201].includes(res.status)) {
      //   commit('setRulesSyntax', res.data);
      // }
      return res.data;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  setRulesAssessment({ commit }, rulesAssessment) {
    commit('setRulesAssessment', rulesAssessment);
  },
  updateCarrierData({ commit }, data) {
    commit('setCarrierData', data);
  },
  async updateCarrierModesOfOperation(_, body) {
    try {
      const res = await axios.post(
        process.env.API_MONITOR + '/api/v1/carrier_modes/bulk_create',
        body
      );
      if ([200, 201].includes(res.status)) {
        return res.data;
      }
      // TODO code refactor pending
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        console.log('returing e.response');
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getAvailableCarrierElectedClassifications({ state, commit, dispatch }) {
    let issuer_id = state.carrierData?.connection?.issuer?.id;
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/classifications?q[company_id_eq]=' +
          issuer_id +
          '&q[is_by_carrier_election_true]=1&q[s]=name+asc'
      );
      if ([200, 201].includes(res.status)) {
        commit('setAvailableCarrierElectedClassifications', res?.data);
        commit('setAvailableCarrierElectedClassificationsHaveLoaded', true);
        dispatch('getCurrentCarrierElectedClassifications');
        return res?.data;
      }
      commit('setAvailableCarrierElectedClassificationsHaveLoaded', true);
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCurrentCarrierElectedClassifications({ state, commit, dispatch }) {
    let connection_id = state.carrierData?.connection?.id;
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/connection_classifications?q[connection_id_eq]=' +
          connection_id
      );
      if ([200, 201].includes(res.status)) {
        commit('setCarrierElectedClassifications', res?.data);
        if (res?.data?.length > 0) {
          await dispatch('completeCarrierElectedClassificationsStage');
        }
        return res?.data;
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async completeCarrierElectedClassificationsStage({ commit }) {
    commit('setHasCompletedCarrierElectedClassificationsStage', true);
  },
  async createOrDeleteConnectionClassification(
    { state, dispatch },
    { elected_classification_id, remove_election_id }
  ) {
    let connection_id = state.carrierData?.connection?.id;
    // let current_carrier_elected = state.carrierElectedClassifications;
    // let match = current_carrier_elected.filter(function(c) {
    //     return c.connection_id == connection_id && c.classification_id == elected_classification_id;
    // });
    console.log('connection_id: ' + connection_id);
    console.log('elected_classification_id: ' + elected_classification_id);
    console.log('remove_election_id: ' + remove_election_id);
    if (remove_election_id == null) {
      let payload = {
        connection_classification: {
          connection_id: connection_id,
          classification_id: elected_classification_id,
        },
      };
      try {
        const res = await axios.post(
          process.env.API_MONITOR + '/api/v1/connection_classifications',
          payload
        );
        if ([200, 201].includes(res.status)) {
          await dispatch('getCurrentCarrierElectedClassifications', res?.data);
          // return res?.data;
        }
        return res;
      } catch (e) {
        if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
          return e.response;
        } else {
          throw e;
        }
      }
    } else {
      // Matching connection_classification has already been created
      console.log(
        'Matching connection_classification has already been created, initiating delete'
      );
      try {
        const res = await axios.delete(
          process.env.API_MONITOR +
            '/api/v1/connection_classifications/' +
            remove_election_id
        );
        if ([204].includes(res.status)) {
          await dispatch('getCurrentCarrierElectedClassifications', res?.data);
          // return res?.data;
        }
        return res;
      } catch (e) {
        if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
          return e.response;
        } else {
          throw e;
        }
      }
    }
  },
  async findOrCreateIdentifier(_, { legalName, dbaName, isType, value }) {
    const body = {
      legal_name: legalName,
      dba_name: dbaName,
      is_type: isType,
      value: value,
    };
    try {
      let res = await axios.post(
        process.env.API_IDENTITY +
          '/sign_up/find_or_create_manually_created_identifier_and_carrier',
        body
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async claimManualCarrier(_, body) {
    const formData = jsonToFormData(body);
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY + '/sign_up/claim_manually_created_carrier',
        formData
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarriersInspections({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/carriers/' + id + '/inspections'
      );
      commit('setInspections', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getCarriersSafety({ commit }, id) {
    try {
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/carriers/' + id + '/safety'
      );
      commit('setSafety', res?.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setShowCarrier(state, carrier) {
    state.showCarrier = carrier;
  },
  setShowCarrierInsights(state, insights) {
    state.showCarrierInsights = insights;
  },
  setShowCarrierHistoricalTouches(state, historicalTouches) {
    state.showCarrierHistoricalTouches = historicalTouches.areas;
  },
  setCarrierSearchResults(state, results) {
    state.searchResults = results;
  },
  setMycarrierResults(state, results) {
    state.myCarrierResults = results;
  },
  setPagination(state, headers) {
    state.pagination = {
      currentPage: parseInt(headers.currentpage),
      totalPages: parseInt(headers.totalpages),
      totalRecords: parseInt(headers.totalitems),
    };
  },
  updateShowCarrierSubscription(state, subscription) {
    state.showCarrier.subscription = subscription;
  },
  setRequestFilters(state, filters) {
    state.filters = filters;
  },
  setCarrierVerification(state, verification) {
    state.carrierVerification = verification;
  },
  setCarrierData(state, el) {
    state.carrierData = el;
  },
  setCarrierDetails(state, el) {
    state.carrierDetails = el;
  },
  setCurrentContracts(state, contracts) {
    state.contracts = contracts;
  },
  setMaskedContacts(state, el) {
    state.maskedContacts = el;
  },
  setRulesAssessment(state, data) {
    if (state.carrierData?.rules_assessment) {
      state.carrierData.rules_assessment = data;
    } else {
      state.carrierData = {
        ...state.carrierData,
        rules_assessment: data,
      };
    }
  },
  setEmailRequiredForLogin(state, isRequired) {
    state.isEmailRequiredForLogin = isRequired;
  },
  setRulesSyntax(state, data) {
    state.rulesSyntax = data;
  },
  setAvailableCarrierElectedClassificationsHaveLoaded(state, bool) {
    state.availableCarrierElectedClassificationsHaveLoaded = bool;
  },
  setAvailableCarrierElectedClassifications(state, data) {
    state.availableCarrierElectedClassifications = data;
  },
  setHasCompletedCarrierElectedClassificationsStage(state, bool) {
    state.hasCompletedCarrierElectedClassificationsStage = bool;
  },
  setCarrierElectedClassifications(state, data) {
    state.carrierElectedClassifications = data;
  },
  setConnectionClassifications(state, data) {
    state.connectionClassifications.push(data);
  },
  setFailedRulesAssessmentData(state, data) {
    state.failedRulesAssessmentData = data;
  },
  setInspections(state, data) {
    state.showCarrierInspections = data;
  },
  setSafety(state, data) {
    state.showCarrierSafety = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
